<script>
    import { onMount } from 'svelte'
    import { browser } from '$app/environment'
    import { _ } from 'svelte-i18n'
    import { getConsentCookieValue, setConsentCookieValue } from '$lib/utilities/cookieConsentUtilities'
    import { enableAnalytics } from '$lib/utilities/AnalyticsTools'

    let modal
    let modalElement = browser && document.getElementById('consentModal')

    let consentGiven = getConsentCookieValue()
    $: consentLinkMessage = $_('cookie-consent.here')

    // Bs javascript relies on document being available. Dynamically import it onMount, so we know for sure
    // that we are in the browser and not in SSR
    onMount(async () => {
        const { Modal } = await import('bootstrap')
        // Check if modal element exists and if consent cookie is not set
        if (modalElement && typeof consentGiven !== 'boolean') {
            modal = new Modal(modalElement)
            modal.show()
        }
    })

    // If we have consent, enable the analytics plugins
    $: if (browser && consentGiven) {
        console.info('Cookie consent has been given.')
        enableAnalytics()
    }

    const handleAccept = () => {
        setConsentCookieValue(true)
        consentGiven = true
    }

    const handleDecline = () => setConsentCookieValue(false)
</script>

<div
    class="modal consent-modal fade"
    id="consentModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="consentModalLabel"
    aria-hidden="true"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <p class="h2 mb-4">{$_('cookie-consent.title')}</p>
                <p>
                    {$_('cookie-consent.message')}
                    <a href="https://www.sirumobile.com/cookie-policy" target="_blank" rel="noopener"
                        >{$_('cookie-consent.here')}</a
                    >.
                </p>
            </div>
            <div class="modal-footer pb-4 pt-2 text-center justify-content-center border-top-0">
                <button
                    type="button"
                    class="btn btn-link my-2 text-uppercase"
                    data-bs-dismiss="modal"
                    on:click={handleDecline}>{$_('cookie-consent.decline')}</button
                >
                <button
                    type="button"
                    class="btn btn-success shadow my-2 py-3 text-uppercase"
                    data-bs-dismiss="modal"
                    on:click={handleAccept}>{$_('cookie-consent.accept')}</button
                >
            </div>
        </div>
    </div>
</div>

<style lang="scss">
    .consent-modal {
        letter-spacing: 1.5px;

        button {
            font-weight: bold;
            font-size: 0.9rem;
            letter-spacing: 1.5px;
            padding-left: 5rem;
            padding-right: 5rem;
        }

        button.btn-link {
            color: var(--bs-gray);
        }

        .modal-content {
            border-radius: 2rem;
        }

        .modal-body {
            border-top-left-radius: 2rem;
            border-top-right-radius: 2rem;

            background-color: var(--bs-light);

            padding: clamp(2rem, 6vw, 4rem) clamp(1.5rem, 8vw, 5rem);
        }
    }
</style>
